module.exports = __webpack_public_path__ + "img/pdf_bg_indice.86201552.png";